module.exports = __webpack_public_path__ + "static/media/my-profile.f79d731a.svg";